export const homeTranslations = {
  // 首页相关翻译
  "discoverPenangTreasures": {
    en: "Discover Penang's Treasures",
    zh: "发现槟城的瑰宝"
  },
  "exploreCulturalDestinations": {
    en: "Explore the island's most beautiful and culturally significant destinations",
    zh: "探索这座岛屿最美丽和最具文化意义的目的地"
  },
  "ourServices": {
    en: "Our Services",
    zh: "我们的服务"
  },
  "comprehensiveSupport": {
    en: "Comprehensive support for visitors, students, and expatriates in Penang",
    zh: "为槟城的游客、学生和外籍人士提供全面支持"
  },
  "aboutPenangGateway": {
    en: "About Penang Gateway",
    zh: "关于槟城门户"
  },
  "aboutParagraph1": {
    en: "Penang Gateway is your comprehensive resource for navigating life in Penang, whether you're a student, tourist, or expatriate.",
    zh: "槟城门户是您在槟城生活的综合资源，无论您是学生、游客还是外籍人士。"
  },
  "aboutParagraph2": {
    en: "We provide up-to-date information, practical guides, and services to help make your transition to Penang smooth and enjoyable.",
    zh: "我们提供最新信息、实用指南和服务，帮助您顺利愉快地适应槟城生活。"
  },
  "aboutParagraph3": {
    en: "Our team of local experts has extensive knowledge about Penang's culture, institutions, and infrastructure to assist with any needs you may have.",
    zh: "我们的本地专家团队对槟城的文化、机构和基础设施有丰富的了解，能够满足您的各种需求。"
  },
  "learnMoreAboutUs": {
    en: "Learn More About Us",
    zh: "了解更多关于我们"
  },
  "penangLandscape": {
    en: "Penang Landscape",
    zh: "槟城景观"
  },
  "trustedByVisitors": {
    en: "Trusted by thousands of visitors and residents since 2010",
    zh: "自2010年以来，受到数千名游客和居民的信赖"
  },
  "readyToExplorePenang": {
    en: "Ready to Explore Penang?",
    zh: "准备好探索槟城了吗？"
  },
  "georgetownHeritage": {
    en: "Georgetown Heritage",
    zh: "乔治城文化遗产"
  },
  "georgetownHeritageDesc": {
    en: "Explore UNESCO-listed streets filled with historic architecture, street art, and diverse cultural influences.",
    zh: "探索被联合国教科文组织列入名录的街道，这里有历史悠久的建筑，街头艺术和多元文化影响。"
  },
  "batuFerringhi": {
    en: "Batu Ferringhi Beach",
    zh: "峇都丁宜海滩"
  },
  "batuFerringhiDesc": {
    en: "Relax on Penang's most popular beach, known for its soft white sand, water sports, and vibrant night market.",
    zh: "在槟城最受欢迎的海滩上放松，这里以柔软的白沙、水上运动和热闹的夜市而闻名。"
  },
  "penangHill": {
    en: "Penang Hill",
    zh: "槟城山"
  },
  "penangHillDesc": {
    en: "Take the funicular railway to the summit for panoramic views, cooler temperatures, and lush tropical gardens.",
    zh: "乘坐缆车到达山顶，欣赏全景，享受凉爽的温度和茂密的热带花园。"
  },
  "butterworthConnection": {
    en: "Butterworth Connection",
    zh: "北海连接"
  },
  "butterworthConnectionDesc": {
    en: "Visit the mainland part of Penang for its commercial centers, transportation hubs, and authentic local experiences.",
    zh: "参观槟城的大陆部分，探索其商业中心、交通枢纽和真实的当地体验。"
  },
  "helpYouMakeTheMost": {
    en: "Let us help you make the most of your time in Penang. Whether you're studying, visiting, or relocating, we've got you covered.",
    zh: "让我们帮助您充分利用在槟城的时间。无论您是学习、参观还是搬迁，我们都能满足您的需求。"
  },
  "diverseCulture": {
    en: "Diverse multicultural society with Malay, Chinese, Indian, and international influences",
    zh: "多元文化社会，融合马来、中国、印度和国际影响"
  },
  "unescoSite": {
    en: "UNESCO World Heritage Site with well-preserved colonial architecture",
    zh: "联合国教科文组织世界遗产地，拥有保存完好的殖民时期建筑"
  },
  "affordableLiving": {
    en: "Affordable cost of living compared to other international destinations",
    zh: "与其他国际目的地相比，生活成本较为经济"
  },
  "internationalAirport": {
    en: "International airport with connections to major Asian cities",
    zh: "国际机场与主要亚洲城市相连接"
  },
  "modernHealthcare": {
    en: "Modern healthcare facilities with English-speaking medical professionals",
    zh: "现代化医疗设施，有会说英语的医疗专业人员"
  },
  "whatPeopleSay": {
    en: "What People Say",
    zh: "人们的评价"
  },
  "hearFromUsers": {
    en: "Hear from our users who have experienced our services",
    zh: "听听体验过我们服务的用户的反馈"
  },
  "internationalStudent": {
    en: "International Student",
    zh: "国际学生"
  },
  "touristFromAustralia": {
    en: "Tourist from Australia",
    zh: "来自澳大利亚的游客"
  },
  "businessTraveler": {
    en: "Business Traveler",
    zh: "商务旅行者"
  },
  "discoverMore": {
    en: "Discover More",
    zh: "发现更多"
  },
  "viewAllDestinations": {
    en: "View All Destinations",
    zh: "查看所有目的地"
  }
};
